import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/4y9fydej_banner-tmd-2.jpg',
      title: 'www.tmdonlinesube.com',
      subtitle: 'Sizin İçin Yenilendi',
      overlay: 'from-blue-900/40 to-blue-800/30'
    },
    {
      id: 2,
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/26xdfwhd_slider-yeni-5.jpeg',
      title: 'Bire Bir Yatırım',
      subtitle: 'Hizmetleri',
      overlay: 'from-slate-500/30 to-slate-400/20'
    },
    {
      id: 3,
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/2lv64wqo_1-ay-banner-2.jpeg',
      title: 'AÇIK YATIRIM',
      subtitle: 'Günümüzün Ötesinde',
      overlay: 'from-slate-600/40 to-slate-500/30'
    }
  ];

  const services = [
    {
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/27rzi598_yurtici-satis-2-radius160.png',
      title: 'YURT İÇİ SATIŞ',
      description: 'Türkiye piyasalarına odaklı çözümler sunuyoruz.',
      link: '/urun-ve-hizmetler/yurt-ici-satis'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/pggf39t4_varlik-yonetimi-1.png',
      title: 'VARLIK YÖNETİMİ',
      description: 'Finansal varlıklarınızı güvenle yönlendiriyoruz.',
      link: '/urun-ve-hizmetler/varlik-yonetimi'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/qc5co48r_kurumsal-finansman-5-4.png',
      title: 'KURUMSAL FİNANSMAN',
      description: 'Şirket finansmanı için güvenilir çözümler.',
      link: '/urun-ve-hizmetler/kurumsal-finansman'
    }
  ];

  const aboutCards = [
    {
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/1qgmlep5_uculke-yeni-1.jpeg',
      title: 'Grubumuzun Tarihçesi',
      link: '/hakkimizda/tarihce'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/fuoxhn0y_bina-yeni-1.jpeg',
      title: 'Bizi Tanıyın',
      link: '/hakkimizda/bizi-taniyin'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/a33yt96j_kurul-yeni-1.jpeg',
      title: 'Kurumsal Yönetim',
      link: '/hakkimizda/kurumsal-yonetim'
    }
  ];

  const newsTabs = [
    'Haberler',
    'Basın Bültenleri',
    'Videolar',
    'Sürdürülebilirlik & Sosyal Sorumluluk'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Slider */}
      <section className="relative h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            <div className={`absolute inset-0 bg-gradient-to-r ${slide.overlay}`}></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white px-4">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-thin mb-2 md:mb-4" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.5)' }}>
                  {slide.title}
                </h1>
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-thin" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.5)' }}>
                  {slide.subtitle}
                </h2>
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-2 md:left-8 top-1/2 -translate-y-1/2 z-10 text-white hover:text-orange-400 transition-colors"
        >
          <ChevronLeft className="w-8 h-8 md:w-12 md:h-12" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 md:right-8 top-1/2 -translate-y-1/2 z-10 text-white hover:text-orange-400 transition-colors"
        >
          <ChevronRight className="w-8 h-8 md:w-12 md:h-12" />
        </button>

        {/* Dots */}
        <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 z-10 flex space-x-2 md:space-x-3">
          {slides.map((slide) => (
            <button
              key={slide.id}
              onClick={() => setCurrentSlide(slides.findIndex(s => s.id === slide.id))}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all ${
                slides[currentSlide].id === slide.id ? 'bg-orange-500 w-6 md:w-8' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Main Content Section - All in One with #383e48 background */}
      <section className="py-16" style={{ backgroundColor: '#383e48' }}>
        <div className="container mx-auto px-4 space-y-16">
          
          {/* Services Subsection */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {services.map((service, index) => (
              <div key={index} className="bg-slate-700/30 rounded-lg p-8 text-center backdrop-blur-sm">
                <div className="w-32 h-32 mx-auto mb-6">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-white font-semibold text-lg mb-3">{service.title}</h3>
                <p className="text-slate-300 text-sm mb-6 min-h-[40px]">{service.description}</p>
                <Link
                  to={service.link}
                  className="inline-block border-2 border-slate-400 text-slate-300 px-6 py-2 rounded-full hover:bg-slate-600 hover:border-slate-300 transition-all text-sm font-medium"
                >
                  Detaylı Bilgi
                </Link>
              </div>
            ))}
          </div>

          {/* About Cards and News - Stacked vertically, same width */}
          <div className="max-w-6xl mx-auto space-y-6">
            {/* Three About Cards - Top Row */}
            <div className="flex gap-6">
              {aboutCards.map((card, index) => (
                <Link
                  key={index}
                  to={card.link}
                  className={`group relative h-96 rounded-3xl overflow-hidden shadow-2xl ${
                    index === 1 ? 'flex-[1.4]' : 'flex-1'
                  }`}
                  style={{
                    boxShadow: '0 10px 40px rgba(0,0,0,0.5), inset 0 0 0 3px rgba(255,255,255,0.1)'
                  }}
                >
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute bottom-10 left-0 right-0 flex items-center justify-center">
                    <div className="inline-block border-[3px] border-white/90 text-white px-10 py-3 rounded-full text-base font-normal backdrop-blur-sm bg-black/10">
                      {card.title}
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* News Section - Bottom Row, Full Width */}
            <div className="relative overflow-hidden h-64 rounded-3xl shadow-2xl" style={{
              boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
            }}>
              {/* Globe Background */}
              <div className="absolute inset-0 flex items-center justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_site-mirror-163/artifacts/nats5lcb_dunya-yeni-1.jpeg"
                  alt="Globe"
                  className="w-full h-full object-cover opacity-40"
                />
              </div>

              <div className="relative z-10 h-full flex flex-col items-center justify-center py-8">
                <div className="inline-flex mb-6">
                  <button className="px-8 py-3 rounded-full bg-white text-slate-800 text-base font-medium shadow-lg hover:shadow-xl transition-shadow">
                    Bizden Haberler
                  </button>
                </div>
                <div className="flex flex-wrap justify-center gap-6 md:gap-8 text-white">
                  {newsTabs.map((tab, index) => (
                    <button
                      key={index}
                      className="hover:text-orange-400 transition-colors text-sm md:text-base font-light"
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Home;